$(function () {
  if (!customElements.get('products-purchase')) {
    customElements.define(
      'products-purchase',
      class productsPurchase extends HTMLElement {
        constructor() {
          super();
          this.$priceContainer = null;
          this.$currentQuantity = 1;
          this.$productsPurchase = null;
          this.$newPrice = 0;
          this.$newComparePrice = 0;
          this.shopMoneyFormat = window.shopMoneyFormat;
        }

        // 添加获取最新DOM元素的方法
        refreshElements() {
          this.$priceContainer = this.querySelector('.price-container');
          this.$totalPriceContainer = this.querySelector('.product-sticky-form-total');
          this.$totalPriceContainer.querySelectorAll('.price-container').forEach((element) => {
            this.$currentPrice = element.getAttribute('data-current-price');
            this.$comparePrice = element.getAttribute('data-compare-price');
          });
          this.priceElement = this.$priceContainer.querySelector('.price');
          this.comparePriceElement = this.$priceContainer.querySelector('.compare_at_price');
          this.actualDiscountElement = this.$priceContainer.querySelector('.actual_discount');
          this.actualDiscountContainer = this.$priceContainer.querySelector('.actual_discount-container');
        }

        connectedCallback() {
          this.$productsPurchase = this.querySelector('.products-purchase');
          this.refreshElements();
          this.bindEvents();
          this.handleAddToCartClick();
          this.handleBuyNowClick();
          const disabledButtons = this.querySelectorAll('button[disabled]');
          disabledButtons.forEach((button) => {
            const link = button.querySelector('a');
            if (link) {
              link.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
              });
              link.style.pointerEvents = 'none';
              link.style.opacity = '0.5';
            }
          });
        }

        disconnectedCallback() {
          window.removeEventListener('quantityChange', this.handleQuantityChange);
          window.removeEventListener('updateResult', this.handleUpdateResult);
        }

        bindEvents() {
          // 绑定数量变化事件
          this.handleQuantityChange = (event) => {
            this.$currentQuantity = event.detail;
            this.updatePrices();
          };
          window.addEventListener('quantityChange', this.handleQuantityChange);

          // 绑定结果更新事件
          this.handleUpdateResult = (event) => {
            console.log('event22', event);
            this.$currentPrice = event.detail.price;
            this.$comparePrice = event.detail.originalComparePrice;
            this.updatePrices();
          };
          window.addEventListener('updateEventShow', this.handleUpdateResult);
        }

        parsePriceString(priceString) {
          console.log('priceString', priceString);
          return priceString;
        }

        updatePrices() {
          // 在更新价格前刷新DOM引用
          this.refreshElements();
          let currentVarTotal = 0;
          let currentCompareVarTotal = 0;
          if (document.querySelectorAll('.products-select-menu')) {
            document.querySelectorAll('.products-select-menu').forEach((element) => {
              const currentPrice = parseFloat(element.getAttribute('data-current-price') || 0);
              const comparePrice = parseFloat(element.getAttribute('data-compare-price') || 0);
              const quantity = parseFloat(element.getAttribute('data-quantity') || 0);

              // 计算并累加总金额
              currentVarTotal += currentPrice * quantity;
              currentCompareVarTotal += comparePrice * quantity;
            });
          }
          console.log('updatePrices执行', {
            currentVarTotal: currentVarTotal,
            currentCompareVarTotal: currentCompareVarTotal,
            $currentQuantity: this.$currentQuantity,
            $currentPrice: this.$currentPrice,
            $comparePrice: this.$comparePrice,
          });
          //找到全局中global-discount组件 带有compute-show的元素
          const globalDiscount = document.querySelectorAll('global-discount.compute-show-container');
          console.log('1231231', globalDiscount);

          // 更新常规价格
          if (this.priceElement) {
            const originalPrice = this.parsePriceString(this.$currentPrice);
            console.log('originalPrice222111', this.$currentPrice);
            console.log('this.$currentQuantity222', originalPrice);
            this.$totalPriceContainer.setAttribute('data-current-currentQuantity', this.$currentQuantity);
            this.$totalPriceContainer.setAttribute('data-current-price', originalPrice);
            this.$newPrice = originalPrice * this.$currentQuantity + currentVarTotal;
            console.log('this.$newPrice111', this.$newPrice);
            console.log('this.$originalPrice', originalPrice);
            console.log('this.shopMoneyFormat111', this.shopMoneyFormat);
            console.log('this.$currentQuantity111', this.$currentQuantity);
            this.priceElement.innerHTML = window.Shopify.formatMoney(this.$newPrice, this.shopMoneyFormat);
          }

          // 更新比较价格
          if (this.comparePriceElement && this.comparePriceElement.innerHTML.trim()) {
            let originalComparePrice = this.parsePriceString(this.$comparePrice);
            console.log('originalComparePrice111', originalComparePrice);
            console.log('this.$currentQuantity111', this.$currentQuantity);
            console.log('currentCompareVarTotal111', currentCompareVarTotal);
            this.$newComparePrice = originalComparePrice * this.$currentQuantity + currentCompareVarTotal;
            this.comparePriceElement.innerHTML = window.Shopify.formatMoney(
              this.$newComparePrice,
              this.shopMoneyFormat
            );
          }
          console.log('riginalComparePrice ', this.parsePriceString(this.$comparePrice));

          // 计算并更新差值
          console.log('this.actualDiscountElement', this.actualDiscountElement);
          console.log('this.actualDiscountElement', this.$newComparePrice);
          console.log('this.actualDiscountElement', this.$newPrice);
          console.log(
            'test',
            JSON.stringify({
              price: this.parsePriceString(this.$newPrice),
              compare_price: this.parsePriceString(this.$newComparePrice),
            })
          );
          globalDiscount.forEach((element) => {
            element.setAttribute(
              'data-total',
              JSON.stringify({
                price: this.parsePriceString(this.$newPrice),
                compare_price: this.parsePriceString(this.$newComparePrice),
              })
            );
          });
          if (this.$newComparePrice > this.$newPrice) {
            const discount = this.$newComparePrice - this.$newPrice;
            if (this.actualDiscountContainer) {
              this.actualDiscountContainer.classList.remove('hidden');
            }
            if (this.parsePriceString(this.$comparePrice) <= 0) {
              if (this.actualDiscountContainer) {
                this.actualDiscountContainer.classList.add('hidden');
              }
              if (this.actualDiscountElement) {
                this.actualDiscountElement.innerHTML = '';
              }
            } else if (this.$newComparePrice - this.$newPrice <= 0) {
              if (this.actualDiscountContainer) {
                this.actualDiscountContainer.classList.add('hidden');
              }
              if (this.actualDiscountElement) {
                this.actualDiscountElement.innerHTML = '';
              }
            } else if (this.$newComparePrice > this.$newPrice) {
              if (this.actualDiscountElement) {
                this.actualDiscountElement.innerHTML = window.Shopify.formatMoney(discount, this.shopMoneyFormat);
              }
            }
          } else {
            if (this.actualDiscountContainer) {
              this.actualDiscountContainer.classList.add('hidden');
            }
            if (this.actualDiscountElement) {
              this.actualDiscountElement.innerHTML = '';
            }
          }
        }

        handleBuyNowClick() {
          const buyNowBtn = this.querySelector('.buy-now-btn');
          if (buyNowBtn) {
            buyNowBtn.addEventListener('click', async (event) => {
              const variantId = this.$productsPurchase.getAttribute('data-variant-id');

              event.preventDefault();
              const quantity = this.$currentQuantity;

              // 获取选中的产品数据
              const selectedProducts = window.selectedProducts || [];

              try {
                const clear_response = await fetch('/cart/clear.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                });
                if (clear_response.ok) {
                  // 使用 Shopify Ajax API 添加商品到购物车
                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      items: [
                        // 添加当前产品
                        {
                          id: parseInt(variantId),
                          quantity: parseInt(quantity),
                        },
                        // 添加其他选中的产品
                        ...selectedProducts.map((product) => ({
                          id: product.variantId,
                          quantity: parseInt(product.quantity),
                        })),
                      ],
                    }),
                  });
                  if (!response.ok) {
                    window.GlobalPrompt.show(window.i18n.quantityError, 'error');
                  }
                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/3GvVCJvMxIsYENOi4Zkp' });
                  }
                  // 添加成功后直接跳转到结账页面
                  window.location.href = '/checkout';
                } else if (!clear_response.ok) {
                  window.GlobalPrompt.show(window.i18n.quantityError, 'error');
                }
              } catch (error) {
                console.error('Error processing buy now:', error);
              }
            });
          }
        }
        handleAddToCartClick() {
          const variantId = this.$productsPurchase.getAttribute('data-variant-id');
          const addToCartBtn = this.querySelector('.add-to-cart-btn');
          if (addToCartBtn) {
            addToCartBtn.addEventListener('click', async (event) => {
              event.preventDefault();
              const quantity = this.$currentQuantity;

              // 获取选中的产品数据
              const selectedProducts = window.selectedProducts || [];

              try {
                // 使用 Shopify Ajax API 添加商品到购物车
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      // 添加当前产品
                      {
                        id: parseInt(variantId),
                        quantity: parseInt(quantity),
                      },
                      // 添加其他选中的产品
                      ...selectedProducts.map((product) => ({
                        id: product.variantId,
                        quantity: parseInt(product.quantity),
                      })),
                    ],
                    sections: 'cart-drawer,cart-icon-bubble',
                  }),
                });
                if (window.gtag) {
                  gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                }
                if (response.ok) {
                  const cartContent = await response.json();
                  await updateCartComponents(cartContent);

                  // 打开购物车抽屉
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    cartDrawer.open();
                  }
                } else {
                  const errorData = await response.json();
                  console.error('Add Cart error:', errorData);
                  window.GlobalPrompt.show(errorData.description || 'Failed to Add to Cart', 'error', 'drawer');
                }
              } catch (error) {
                console.error('Error:', error);
                window.GlobalPrompt.show('Failed to Add to Cart', 'error', 'drawer');
              }
            });
          }
        }
      }
    );
  }
});
